import React from 'react';
import MetricCard from '../common/MetricCard';
import CyberBadge from '../common/CyberBadge';
import { Wallet, DollarSign, ArrowUpRight, CreditCard, ShieldCheck } from 'lucide-react';

export default function FinanceView({ payments = [], bookings = [], stats }) {
  const grossRev = stats?.grossRevenue || '3,675';
  const commission = Math.round((parseFloat(grossRev.replace(',', '')) || 3675) * 0.05);

  return (
    <div className="animate-fade" style={{ display: 'flex', flexDirection: 'column', gap: '28px' }}>
      {/* Header */}
      <div>
        <h1 style={{ fontSize: '1.75rem', fontWeight: 900, color: 'var(--text-primary)', letterSpacing: '-0.02em', margin: 0, display: 'flex', alignItems: 'center', gap: '10px' }}>
          <Wallet size={28} style={{ color: 'var(--neon-amber)' }} /> Financial Overview & Commission Ledger
        </h1>
        <p style={{ fontSize: '0.85rem', color: 'var(--text-secondary)', marginTop: '4px' }}>
          Platform gross transaction revenue, automated captain payout splits, and 5% commission revenue.
        </p>
      </div>

      {/* Financial Metrics */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))', gap: '20px' }}>
        <MetricCard
          title="PLATFORM GROSS VOLUME"
          value={`₹${grossRev}`}
          subtext="Total transaction volume across nodes"
          change="+18.4%"
          changeType="up"
          icon={DollarSign}
          glowColor="amber"
        />
        <MetricCard
          title="5% PLATFORM COMMISSION"
          value={`₹${commission}`}
          subtext="Net platform earnings"
          change="Automated Cut"
          changeType="up"
          icon={ArrowUpRight}
          glowColor="emerald"
        />
        <MetricCard
          title="CAPTAIN PAYOUT POOL"
          value={`₹${(parseFloat(grossRev.replace(',', '')) || 3675) - commission}`}
          subtext="Processed to verified captains"
          change="Settled"
          changeType="neutral"
          icon={CreditCard}
          glowColor="cyan"
        />
      </div>

      {/* Transaction History Ledger */}
      <div className="cyber-card" style={{ padding: '0', overflow: 'hidden' }}>
        <div style={{ padding: '20px 24px', borderBottom: '1px solid var(--border-color)', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <h3 style={{ fontSize: '1.1rem', fontWeight: 800, color: 'var(--text-primary)', margin: 0 }}>
            Recent Platform Transaction Ledger
          </h3>
          <span className="badge badge-amber">
            <ShieldCheck size={12} /> SECURE GATEWAY
          </span>
        </div>

        <div className="table-container" style={{ border: 'none' }}>
          <table className="table">
            <thead>
              <tr>
                <th>TRANSACTION ID</th>
                <th>MODULE / ITEM</th>
                <th>TOTAL AMOUNT</th>
                <th>CAPTAIN SPLIT</th>
                <th>COMMISSION (5%)</th>
                <th>STATUS</th>
              </tr>
            </thead>
            <tbody>
              {[
                { id: 'TXN-90214', item: 'Ground Turf Slot #4', amt: '₹1,200', capt: '₹1,140', comm: '₹60', status: 'completed' },
                { id: 'TXN-90215', item: 'Cypher Hotzone Booking', amt: '₹1,500', capt: '₹1,425', comm: '₹75', status: 'completed' },
                { id: 'TXN-90216', item: 'Gym Pass Monthly', amt: '₹975', capt: '₹926', comm: '₹49', status: 'completed' },
              ].map((tx, idx) => (
                <tr key={idx}>
                  <td style={{ fontWeight: 800, fontFamily: 'var(--font-mono)', color: 'var(--neon-cyan)' }}>{tx.id}</td>
                  <td style={{ fontWeight: 700 }}>{tx.item}</td>
                  <td style={{ fontWeight: 800, color: 'var(--text-primary)' }}>{tx.amt}</td>
                  <td style={{ color: 'var(--text-secondary)' }}>{tx.capt}</td>
                  <td style={{ fontWeight: 800, color: 'var(--neon-emerald)' }}>{tx.comm}</td>
                  <td><CyberBadge status={tx.status} /></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
